import type { ISelectOption } from 'stories/components/SelectOptionInputs/types'

export type InputOptions = Array<string | Partial<ISelectOption>> | Record<string, string | null>

export function normalizeOptions(options?: InputOptions): ISelectOption[] {
  if (!options) return []

  if (Array.isArray(options)) {
    return options.map((option) => {
      if (typeof option === 'string') {
        return {
          key: option,
          title: option,
          visible: true,
          isCustom: false,
        }
      }

      const title = option.title ?? option.key ?? ''

      return {
        ...option,
        key: option.key ?? title,
        title,
        visible: option.visible ?? true,
        isCustom: option.isCustom ?? false,
      }
    })
  }

  return Object.entries(options)
    .filter(([, title]) => title !== null)
    .map(([key, title]) => ({
      key,
      title: title ?? key,
      visible: true,
      isCustom: false,
    }))
}
